module.exports = __webpack_public_path__ + "static/media/iconfont.64942c1e.svg";